import { useModal } from 'src/components/modal';
import { BoardTableRowDialog } from './lazy';
import { BoardTableRowDialogProps } from './shared/types';

export const useBoardTableRowDialog = () => {
  const { hideModal, showModal } = useModal(BoardTableRowDialog, []);

  return {
    hideBoardTableRowDialog: hideModal,
    showBoardTableRowDialog: (
      props: Omit<BoardTableRowDialogProps, 'handleReOpen'>,
    ) => {
      const handleReOpen = (
        data: Omit<BoardTableRowDialogProps, 'handleReOpen'>,
      ) => {
        hideModal();
        showModal({ ...data, handleReOpen });
      };
      showModal({ ...props, handleReOpen });
    },
  };
};
